"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import YouTubePlayer from "../jobadvideo/youtube-eon";
function getRandomInt(max: number): number {
  return Math.floor(Math.random() * max);
}
export default function Diversity(_props) {
  const $ = _c(13);
  const t = useLanguage();
  const [imageInt] = useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${process.env.NEXT_PUBLIC_ASSET_URL}images/jobad/diversity-bg.webp)`,
      backgroundSize: "cover"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `images/jobad/Diversity_Thumbnail${imageInt}.jpg`;
  let t2;
  if ($[1] !== t1) {
    t2 = <div className="my-auto"><YouTubePlayer thumbnailSrc={t1} videoId="s4uEIqB5fcE" /></div>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t.jobad_diversityHL) {
    t3 = <div className="mb-8 flex font-bold text-4xl text-primary lg:justify-end"><h2 className="lg:w-96 lg:text-right" data-source="lc">{t.jobad_diversityHL}</h2></div>;
    $[3] = t.jobad_diversityHL;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t.jobad_diversity_text) {
    t4 = <div className="text-foreground text-lg print:text-sm" dangerouslySetInnerHTML={{
      __html: t.jobad_diversity_text
    }} data-source="lc" />;
    $[5] = t.jobad_diversity_text;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="bg-white p-6 md:p-10">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <section className="outer-container py-container [@media(hover:hover)_and_(pointer:fine)]:bg-fixed" id="diversity" style={t0}><div className="inner-container grid gap-x-20 gap-y-12 lg:grid-flow-col lg:grid-cols-2">{t2}{t5}</div></section>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp() {
  return getRandomInt(4);
}